import React from 'react';
import { Link } from 'gatsby';

const Navigation = () => {
  const [openBurgerClassName, setOpenBurgerClassName] = React.useState('');

  const toggleOpenHamBurgerMenu = () => {
    if (!openBurgerClassName) return setOpenBurgerClassName('is-active');
    return setOpenBurgerClassName('');
  };

  return (
    <nav
      className="navbar has-shadow is-fixed-top"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="navbar-brand">
        <a
          className="navbar-item"
          href="/"
          style={{ transform: 'skewX(-15deg)' }}
        >
          <span className="button is-dark">Interview React</span>
        </a>
        <button
          className={`navbar-burger ${openBurgerClassName}`}
          aria-label="menu"
          aria-expanded="false"
          onClick={toggleOpenHamBurgerMenu}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div
        id="navbarBasicExample"
        className={`navbar-menu ${openBurgerClassName}`}
      >
        <div className="navbar-end">
          <div className="navbar-item">
            <Link
              className="button is-link is-outlined is-rounded"
              activeClassName="is-focused"
              to="/"
            >
              <div className="level">
                <div className="level-item">
                  <span className="nav-desc mx-2">Home</span>
                </div>
              </div>
            </Link>
          </div>
          <div className="navbar-item">
            <Link
              partiallyActive
              className="button is-link is-outlined is-rounded"
              activeClassName="is-focused"
              to="/interview-questions/reactjs-question-answer/"
            >
              <div className="level">
                <div className="level-item">
                  <span className="nav-desc mx-2">React Question</span>
                </div>
              </div>
            </Link>
          </div>
          <div className="navbar-item">
            <Link
              partiallyActive
              className="button is-link is-outlined is-rounded"
              activeClassName="is-focused"
              to="/company-interviews/"
            >
              <div className="level">
                <div className="level-item">
                  <span className="nav-desc mx-2">Comapny Interviews</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
